const ADD_ON_PARAM = 'add_on_id';
// Links shared before add-ons had their name still carry it.
const LEGACY_ADD_ON_PARAM = 'article_id';

/** A link that names a piece: the reader opens it on load. */
export const addOnLink = (url: string, addOnId: string | number): string => {
    const link = new URL(url);
    link.searchParams.set(ADD_ON_PARAM, String(addOnId));
    return link.toString();
};

/** The piece a link names, or null when it names none. */
export const addOnIdFromLink = (url: string): string | null => {
    const params = new URL(url).searchParams;
    return params.get(ADD_ON_PARAM) ?? params.get(LEGACY_ADD_ON_PARAM);
};
